<template>
  <iv-modal
    :title="modal.title"
    v-model="modal.shown"
    :mask-closable="modal.maskClosable"
    :closable="modal.closable"
    :width="modal.width"
    :transfer="modal.transfer"
    :scrollable="modal.scrollable"
    :class-name="'vertical-center-modal'"
    :styles="style"
    @on-cancel="onCancel"
  >
    <h1 slot="header" class="siteName">{{siteName}}</h1>
    <iv-alert show-icon :type="alert.type" style="margin-bottom:1rem">{{alert.errorMsg}}</iv-alert>
    <iv-form ref="account" :model="user" label-position="left" :label-width="45" :rules="validation" :show-message="false">
        <iv-form-item label="帐号" prop="username">
            <input class="ivu-input" type="text" placeholder="帐号" v-model="user.username" @keyup.enter="login(user)" />
        </iv-form-item>
        <iv-form-item label="密码" prop="password" style="margin-bottom:0">
            <input class="ivu-input" type="password" placeholder="密码" v-model="user.password" @keyup.enter="login(user)" />
        </iv-form-item>
    </iv-form>
    <div slot="footer">
        <iv-button class="btn-full" :loading="loader.defaults" type="primary" @click="login(user)">登录</iv-button>
    </div>
  </iv-modal>
</template>
<style lang="scss" scoped>
    .siteName{
      font-size: 18px;
      text-shadow: 1px 2px 0 #ddd;
      color: #353535;
      text-align: center;
      margin-top: 10px;
      margin-bottom: 8px;
    }
    .ivu-form{
    }
    .remember{
        margin-bottom: 1em;
    }
    .btn-full{
        display: block;
        width: 100%;
        line-height: 29px;
        font-size: 16px;
    }
</style>
<script>
import LayoutFooter from "@/pages/commons/Footer";
import { mapActions, mapMutations, mapGetters } from 'vuex';
import {
  LOGIN,
  LOGOUT
} from '@/stores/types';
export default {
    name: "LoginModal",
    components:{
      LayoutFooter
    },
    props: {
      params: {
        type: Object,
        default: () => ({}),
      },
      shown: Boolean
    },
    watch: {
      shown(val) {
        this.refresh();
        this.shown = val
        this.marginTop = document.body.scrollTop;
      },
      'user.password'(){
          this.$refs.account.fields.find(item=>item.prop=='password').$emit('on-form-change');
      }
    },
    data(){
        return {
            modal: {
              shown: false,
              title: "登录",
              maskClosable: false,
              closable: process.env.NODE_ENV !== 'production',
              width: 360,
              scrollable: false,
              transfer: false,
            },
            alert: {
              type: "error",
              errorMsg: "你的账号已失效，请重新登录！",
            },
            siteName: process.env.VUE_APP_SITE_NAME||"登录",
            user: {
                username: '',
                password: ''
            },
            remember: true,
            status: {
                loader: {
                    defaults: false
                }
            },
            validation: {
                username(rule, value, callback, source, options){
                    const errors = [];
                    if(typeof value === 'string'){
                        if(!value) errors.push(new Error('账号不能为空'));
                    }
                    console.log(errors)
                    callback(errors);
                },
                password(rule, value, callback, source, options){
                    const errors = [];
                    if(typeof value === 'string'){
                        if(!value) errors.push(new Error('密码不能为空'));
                    }
                    callback(errors);
                }
            },
        }
    },
    methods: {
      ...mapActions([LOGIN, LOGOUT]),
      $$loading(type="defaults"){
        this.loader[type] = true;
      },
      $$loaded(type="defaults"){
        this.loader[type] = false;
      },
      async login(account){
        const [errorMsg, validate] = await this.validate();
        console.log("login",errorMsg,validate);
        if(!validate) {
          this.alert.errorMsg = errorMsg
          this.alert.type="warning"
          return
        }
        this.$ivLoading.start();
        this.$$loading();
        try{
          await this[LOGIN]({userName: account.username, pwd: account.password}); //cc:login#0;login in ui function;
          this.$ivLoading.finish();
          this.$$loaded();
          this.hide()
        }catch(e){
          this.$$error(e);
          this.$ivLoading.error();
          this.$$loaded();
        }
        this.$ivLoading.finish();
      },
      validate(){
        const $form = this.$refs.account
        return new Promise((resolve, reject) => {
            let valid = true;
            //** TODO: 循环处理异步处理后，把空值过滤掉，剩下的errors数组再进行判断错误情况 */

            Promise.all(
              $form.fields.map(field => new Promise((resolve, reject) => field.validate('', errorMsg => resolve(errorMsg))))
            )
            .then(errors => {
              valid = errors.filter(error => !!error).length == 0
              resolve([errors.filter(error => !!error).shift(), valid])
            }, reject)
        });
      },
      onCancel() {
        this.$refs.account.resetFields();
        this.alert = {
          type: "error",
          errorMsg: "你的账号已失效，请重新登录！",
        }
        this.modal.shown = false;
      },
      show(){
        this.modal.shown = true
      },
      hide(){
        this.modal.shown = false
      }
    },
    computed: {
      loader(){
          return this.status.loader;
      },
      style() {
        return { marginTop: document.body.scrollTop || document.documentElement.scrollTop + "px" };
      },
    },
}
</script>
